// export const initialFormState = {
//   planogramEditionId: 3,
//   minSalesCurrency: 40,
//   minSalesUnits: 50,
//   minDailySalesRateCurrency: 22,
//   minDailySalesRateUnits: 10,
//   numRecentDays: 30,
//   isAllStores: true,
//   isStoreTags: false,
//   storeIds: [],
//   tagIds: [],
//   sales: 1000,
//   saleUnits: 50,
//   profit: 500,
//   dailySaleRateUnits: 22,
//   isNormalized: false,
//   minFace: 10,
//   isBasedOnShare: true,
//   isMaxVerity: false,
//   activeTab: 'stores',
// }

// Default form values
export const initialFormState = {
  planogramEditionId: 0,
  numRecentDays: 0,

  sales: 0,
  saleUnits: 0,
  profit: 0,
  dailySaleRateUnits: 0,

  minSalesCurrency: 0,
  minSalesUnits: 0,
  minDailySalesRateCurrency: 0,
  minDailySalesRateUnits: 0,
  minFace: 0,

  isAllStores: true,
  isStoreTags: true,
  isNormalized: false,
  isBasedOnShare: true,
  isMaxVerity: false,

  stores: [],
  tags: [],
  activeTab: 'stores',
}

export const mandatoryTableHeadersKeys = [
  'hierarchyCode',
  'hierarchyName',
  'allocatedShare',
  'weightedShare',
]

export const preferenceTableItems = [
  {
    label: 'HIERARCHY_CODE',
    id: 'hierarchyCode',
    // info: 'TABLE_PREFERENCE_KEYS.HIERARCHY_CODE_DESC',
    info: null,
  },
  {
    label: 'HIERARCHY_NAME',
    id: 'hierarchyName',
    // info: 'TABLE_PREFERENCE_KEYS.HIERARCHY_NAME_DESC',
    info: null,
  },
  {
    label: 'ALLOCATED_SHARE',
    id: 'allocatedShare',
    info: 'TABLE_PREFERENCE_KEYS.ALLOCATED_SHARE_DESC',
  },
  {
    label: 'WEIGHTED_SHARE',
    id: 'weightedShare',
    info: 'TABLE_PREFERENCE_KEYS.WEIGHTED_SHARE_DESC',
  },
  {
    label: 'DELTA',
    id: 'delta',
    info: 'TABLE_PREFERENCE_KEYS.DELTA_DESC',
  },
  {
    label: 'BARCODE_COUNT',
    id: 'barcodeCount',
    info: 'TABLE_PREFERENCE_KEYS.BARCODE_COUNT_DESC',
  },
  {
    label: 'AVG_PRICE_PER_PROD',
    id: 'avgPricePerProduct',
    info: 'TABLE_PREFERENCE_KEYS.AVG_PRICE_PER_PROD_DESC',
  },
  {
    label: 'SALES_UNITS',
    id: 'salesUnits',
    info: 'TABLE_PREFERENCE_KEYS.SALES_UNITS_DESC',
  },
  {
    label: 'SALES_CURRENCY',
    id: 'salesCurrency',
    info: 'TABLE_PREFERENCE_KEYS.SALES_CURRENCY_DESC',
  },
  {
    label: 'PROFIT_CURRENCY',
    id: 'profitCurrency',
    info: 'TABLE_PREFERENCE_KEYS.PROFIT_CURRENCY_DESC',
  },
  {
    label: 'PROFITABILITY',
    id: 'profitabilityPercentage',
    info: 'TABLE_PREFERENCE_KEYS.PROFITABILITY_DESC',
  },
  {
    label: 'DAL_SALE_RATE_CURRENCY',
    id: 'dailySalesRateCurrency',
    info: 'TABLE_PREFERENCE_KEYS.DAL_SALE_RATE_CURRENCY_DESC',
  },
  {
    label: 'DAL_SALE_RATE_UNIT',
    id: 'dailySalesRateUnits',
    info: 'TABLE_PREFERENCE_KEYS.DAL_SALE_RATE_UNIT_DESC',
  },
]


